module.exports = __webpack_public_path__ + "img/project_banner_1.5e0b2b96.jpg";